import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const HamburgerCloseIcon = memo(({ width=20, height=20, color='#FFFFFF' }) => {
    return (
        <svg width={width} height={height} fill={color} viewBox='0 0 12.7 12.7'>
            <path fillRule='evenodd' clipRule='evenodd' d='M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11
                c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2'/>
            <path fillRule='evenodd' clipRule='evenodd' d='M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11
                c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2'/>
        </svg>
    )
});

HamburgerCloseIcon.displayName = 'HamburgerCloseIcon';

HamburgerCloseIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
